import React from 'react';

export interface IProps {
  width: number;
  height: number;
  fill?: string;
}

const UnionTableIcon = ({
  width, height, fill,
}: IProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path d="M11.0445 0.5H13.5V10.1537C13.5 11.2119 13.2706 12.1426 12.8117 12.9459C12.3572 13.7492 11.7174 14.3769 10.8923 14.829C10.0672 15.2763 9.10309 15.5 8 15.5C6.8925 15.5 5.92619 15.2763 5.10108 14.829C4.27597 14.3769 3.63618 13.7492 3.18171 12.9459C2.72724 12.1426 2.5 11.2119 2.5 10.1537V0.5H4.95548V9.93001C4.95548 10.5457 5.07902 11.094 5.32611 11.575C5.57762 12.056 5.93061 12.4336 6.38508 12.7078C6.83955 12.9772 7.37786 13.1118 8 13.1118C8.62214 13.1118 9.16045 12.9772 9.61492 12.7078C10.0738 12.4336 10.4268 12.056 10.6739 11.575C10.921 11.094 11.0445 10.5457 11.0445 9.93001V0.5Z" fill={fill} />
  </svg>
);

UnionTableIcon.defaultProps = {
  fill: 'var(--purpleColor)',
};

export default UnionTableIcon;
